/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BlockContent } from '../../models/block-content';

export interface ApiMasterBlockContentGetAllGet$Params {
}

export function apiMasterBlockContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterBlockContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<BlockContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterBlockContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<BlockContent>>;
    })
  );
}

apiMasterBlockContentGetAllGet.PATH = '/api/Master/BlockContent/GetAll';
